import React, { Component, Fragment, createRef } from "react";

import { connect } from "react-redux";
import * as actionCreators from "../../../Store/actions/index";
import axios from "axios";
// import * as actionCreators from "../../../Store/actions/index";
import classes from "./PostOption.module.css";
import Map from "../../../Components/UI/Map/Map";
import toggeList from "../../../assets/svg/toggeList.svg";
// import rightBlackarrow from "../../../assets/svg/rightBlackarrow.svg";
// FORM ICONS:
import Hatchback from "../../../assets/svg/Hatchback.svg";
import Sedan from "../../../assets/svg/Sedan.svg";
import MUV from "../../../assets/svg/MUV.svg";
import Crossover from "../../../assets/svg/Crossover.svg";
import Coupe from "../../../assets/svg/Coupe.svg";
import SUV from "../../../assets/svg/SUV.svg";
import Convertible from "../../../assets/svg/Convertible.svg";
import Quadricycle from "../../../assets/svg/Quadricycle.svg";
import AMT from "../../../assets/svg/AMT.svg";
import Manual from "../../../assets/svg/Manual.svg";
import Automatic from "../../../assets/svg/Automatic.svg";
import Petrol from "../../../assets/svg/Petrol.svg";
import HybirdPetrol from "../../../assets/svg/Hybird&Petrol.svg";
import Electric from "../../../assets/svg/Electric.svg";
import Diesel from "../../../assets/svg/Diesel.svg";
import Gas from "../../../assets/svg/Gas.svg";
import Chopper from "../../../assets/svg/Chopper.svg";
import ATV from "../../../assets/svg/ATV.svg";
import Enduro from "../../../assets/svg/Enduro.svg";
import Scooter from "../../../assets/svg/Scooter.svg";
import Sport from "../../../assets/svg/Sport.svg";
import Street from "../../../assets/svg/Street.svg";
import Cross from "../../../assets/svg/Cross.svg";
import Cruiser from "../../../assets/svg/Cruiser.svg";
import SportTourist from "../../../assets/svg/SportTourist.svg";
import Underbone from "../../../assets/svg/Underbone.svg";
import Naked from "../../../assets/svg/Naked.svg";
import Touring from "../../../assets/svg/Touring.svg";
import Boat from "../../../assets/svg/Boat.svg";
import Bus from "../../../assets/svg/Bus.svg";
import Forklift from "../../../assets/svg/Forklift.svg";
import Lorry from "../../../assets/svg/Lorry.svg";
import Taxi from "../../../assets/svg/Taxi.svg";
import Tractor from "../../../assets/svg/Tractor.svg";
import Trailer from "../../../assets/svg/Trailer.svg";
import Van from "../../../assets/svg/Van.svg";
import Trike from "../../../assets/svg/Trike.svg";
//CAR IMAGES:
import carimgOne from "../../../assets/Img/CarIcon/1.png";
import carimgTow from "../../../assets/Img/CarIcon/2.png";
import carimgThree from "../../../assets/Img/CarIcon/3.png";
import carimgFour from "../../../assets/Img/CarIcon/4.png";
import carimgFive from "../../../assets/Img/CarIcon/5.png";
import carimgSix from "../../../assets/Img/CarIcon/6.png";
import carimgSeven from "../../../assets/Img/CarIcon/7.png";
import carimgEghit from "../../../assets/Img/CarIcon/8.png";
import carimgNine from "../../../assets/Img/CarIcon/9.png";
import carimgTen from "../../../assets/Img/CarIcon/10.png";
import carimgEleven from "../../../assets/Img/CarIcon/11.png";
import carimgTwelv from "../../../assets/Img/CarIcon/12.png";
//MOTOTR IMAGES:
import motorOne from "../../../assets/Img/MotorIcon/Motor2.png";
import motorTow from "../../../assets/Img/MotorIcon/Motor4.png";
import motorThree from "../../../assets/Img/MotorIcon/Motor3.png";
import motorFour from "../../../assets/Img/MotorIcon/Motor1.png";
import motorFive from "../../../assets/Img/MotorIcon/Motor5.png";
import motorSix from "../../../assets/Img/MotorIcon/Motor6.png";
//COMMERCIAL IMAGES :
import commercialOne from "../../../assets/Img/commercial/commercialOne.png";
import commercialTwo from "../../../assets/Img/commercial/commercialThree.png";
import commercialThree from "../../../assets/Img/commercial/commercialTwo.png";
/*#################################### CONSTS #################################### */

const ICONS = {
  Hatchback: Hatchback,
  Sedan: Sedan,
  MUV: MUV,
  Crossover: Crossover,
  Coupe: Coupe,
  SUV: SUV,
  Convertible: Convertible,
  Quadricycle: Quadricycle,
  AMT: AMT,
  Manual: Manual,
  Automatic: Automatic,
  HybirdPetrol: HybirdPetrol,
  Electric: Electric,
  Petrol: Petrol,
  Diesel: Diesel,
  Gas: Gas,
  Chopper: Chopper,
  ATV: ATV,
  Enduro: Enduro,
  Scooter: Scooter,
  Sport: Sport,
  Street: Street,
  Cross: Cross,
  Cruiser: Cruiser,
  SportTourist: SportTourist,
  Underbone: Underbone,
  Naked: Naked,
  Touring: Touring,
  Boat: Boat,
  Bus: Bus,
  Forklift: Forklift,
  Lorry: Lorry,
  Taxi: Taxi,
  Tractor: Tractor,
  Trailer: Trailer,
  Van: Van,
  Trike: Trike,
};

// const vehicleTypes = {
//     cars: 'cars',
//     motors: 'motors',
//     commercials: 'commercials',
//     accessories: 'accessories',
//     parts: 'parts',
//     dealers: 'dealers',
//     services: 'services',
//     rental: 'rental',
// }

const CONDITION = {
  new: "new",
  used: "used",
  recon: "recon",
};

const BODY_TYPE = {
  Hatchback: "Hatchback",
  Sedan: "Sedan",
  MUV: "MUV",
  Crossover: "Crossover",
  Coupe: "Coupe",
  SUV: "SUV",
  Convertible: "Convertible",
  Quadricycle: "Quadricycle",
};

const MOTORS_BODY_TYPE = {
  Chopper: "Chopper",
  ATV: "ATV",
  Enduro: "Enduro",
  Scooter: "Scooter",
  Sport: "Sport",
  Street: "Street",
  Cross: "Cross",
  Cruiser: "Cruiser",
  SportTourist: "SportTourist",
  Underbone: "Underbone",
  Naked: "Naked",
  Touring: "Touring",
  Trike: "Trike",
};

const COMMERCIALS_BODY_TYPE = {
  Boat: "Boat",
  Bus: "Bus",
  Forklift: "Forklift",
  Lorry: "Lorry",
  Taxi: "Taxi",
  Tractor: "Tractor",
  Trailer: "Trailer",
  Van: "Van",
};

const TRANSMISSION = {
  AMT: "AMT",
  Manual: "Manual",
  Automatic: "Automatic",
};

const DREVIEN_WHEEL = {
  FourWD: "4WD",
  AWD: "AWD",
  FWD: "FWD",
  RWD: "RWD",
};

const FUEL_TYPE = {
  HybirdPetrol: "HybirdPetrol",
  Electric: "Electric",
  Petrol: "Petrol",
  Diesel: "Diesel",
};

const MOTORS_FUEL_TYPE = {
  Electric: "Electric",
  Petrol: "Petrol",
  Diesel: "Diesel",
};

const COMMERCIALS_FUEL_TYPE = {
  Petrol: "Petrol",
  Electric: "Electric",
  Gas: "Gas",
  Diesel: "Diesel",
};

// const STATES = ['Kuala Lumpur', 'Johor', 'Kedah', 'Labuan', 'Melaka', 'Negeri', 'Sembilan', 'Pahang Perak', 'Perlis', 'Pulau Pinang', 'Putrajaya', 'Sabah Sarawak', 'Selangor', 'Terengganu', 'Wilayah Persekutuan'];

/*#################################################################################### */
/* ############################# SEARCH OPTION CLASS ############################# :*/
/*#################################################################################### */

class SearchOptions extends Component {
  state = {
    //Coordinate:
    coords: null,
    //################## TOGGLING STATE:
    showVideos: true,
    showImages: true,
    showTechnical: true,
    //################## VIDEO STATE:
    video: {
      vidEdited: false,
      editedVidSrc: null,
      editedVidSize: null,
      editedVidType: null,
    },
    //################## IMGAES STATE:
    imageIsntTouched: true,
    imgOne: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgTow: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgThree: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgFour: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgFive: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgSix: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgSeven: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgEghit: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgNine: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgTen: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgEleven: {
      imgEdited: false,
      editedImgSrc: null,
    },
    imgTwelv: {
      imgEdited: false,
      editedImgSrc: null,
    },
    //############################### OPTIONAL IMAGES -_-:

    optinalOne: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinaltwo: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalThree: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalFour: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalFive: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalSix: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalSeven: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalEeight: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalNine: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalEleven: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalTwelev: {
      imgEdited: false,
      editedImgSrc: null,
    },
    optinalThirteen: {
      imgEdited: false,
      editedImgSrc: null,
    },
    // ############################## FIELDS VALUE :
    title: this.props.postToEdit ? this.props.postToEdit.title : "",
    sellerPitch: this.props.postToEdit
      ? this.props.postToEdit.seller_pitch
      : "",
    vehicleCondition: this.props.postToEdit
      ? this.props.postToEdit.condition
      : "",
    bodyType: this.props.postToEdit ? this.props.postToEdit.body_type : "",
    transmission: this.props.postToEdit
      ? this.props.postToEdit.transmission
      : "",
    drivenWheel: this.props.postToEdit
      ? this.props.postToEdit.driven_wheel
      : "",
    fuelType: this.props.postToEdit ? this.props.postToEdit.fuel_type : "",
    vehicle_make_id: this.props.postToEdit
      ? this.props.postToEdit.vehicle_make_id
      : "",
    vehicle_model_id: this.props.postToEdit
      ? this.props.postToEdit.vehicle_model_id
      : "",
    vehicle_variant_id: this.props.postToEdit
      ? this.props.postToEdit.vehicle_variant_id
      : "",
    year_of_manufacture: this.props.postToEdit
      ? this.props.postToEdit.year_of_manufacture
      : "",
    Price: this.props.postToEdit ? this.props.postToEdit.price : "",
    Milage: this.props.postToEdit
      ? this.props.postToEdit.mileage.toString()
      : "",
    country_id: this.props.postToEdit ? this.props.postToEdit.country_id : "",
    state_id: this.props.postToEdit ? this.props.postToEdit.state_id : "",
    area_id: this.props.postToEdit ? this.props.postToEdit.area_id : "",

    // ############################### FETCHED ARRIES :

    makes: [],
    models: [],
    filterdModels: [],
    variants: [],
    filtredVariants: [],
    milageValues: [],
    priceValues: [],
    countries: [],
    states: [],
    areas: [],
    filterdStates: [],
    filterdAreas: [],

    // ################################ EDIT POST EXISTED IMAGES :

    imgOneSrc: null,
    imgTowSrc: null,
    imgThreeSrc: null,
    imgFourSrc: null,
    imgFiveSrc: null,
    imgSixSrc: null,
    imgSevenSrc: null,
    imgEghitSrc: null,
    imgNineSrc: null,
    imgTenSrc: null,
    imgElevenSrc: null,
    imgTwelvSrc: null,
    optinalOneSrc: null,
    optinaltwoSrc: null,
    optinalThreeSrc: null,
    optinalFourSrc: null,
    optinalFiveSrc: null,
    optinalSixSrc: null,
    optinalSevenSrc: null,
    optinalEeightSrc: null,
    optinalNineSrc: null,
    optinalElevenSrc: null,
    optinalTwelevSrc: null,
    optinalThirteenSrc: null,
  };

  componentDidMount() {
    this.fetchVihecleMakeModelVariant(this.props.vihecleType);
    this.milageGenerators();
    if (this.props.postToEdit) {
      this.ExistedImagesHandler();
    }
  }

  componentDidUpdate(prevProp, prevState) {
    if (prevProp !== this.props) {
      this.fetchVihecleMakeModelVariant(this.props.vihecleType);
    }
  }

  // ############################################# TOGGEL SECTION METHODS :
  optionRef = createRef();
  imgRef = createRef();
  toggelShowSection = (showMode) => {
    this.setState((prevState) => {
      return {
        [`${showMode}`]: !prevState[`${showMode}`],
      };
    });
    if (showMode === "showImages") {
      this.timer = setTimeout(() => {
        this.scrollToMyRef(showMode);
      }, 100);
    }
    if (showMode === "showTechnical") {
      this.timer = setTimeout(() => {
        this.optionRef.current.focus();
        this.scrollToMyRef(showMode);
      }, 100);
    }
  };
  scrollToMyRef = (showMode) => {
    if (showMode === "showTechnical") {
      window.scrollTo(0, this.optionRef.current.offsetTop - 150);
    } else {
      window.scrollTo(0, this.imgRef.current.offsetTop);
    }
    clearTimeout(this.timer);
  };

  // ############################################# FETCHED ARRIES METHODS :

  vehicleTypeFormater = (type) => {
    switch (type) {
      case "car":
        return (type = "cars");
      case "motor":
        return (type = "motors");
      case "commercial":
        return (type = "commercials");
      default:
        return type;
    }
  };

  fetchVihecleMakeModelVariant(type) {
    type = this.vehicleTypeFormater(type);
    if (type === "cars" || type === "motors" || type === "commercials") {
      axios
        .get(`${type}/makes`)
        .then((response) => {
          this.setState({
            makes: response.data.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(`${type}/models`)
        .then((response) => {
          this.setState({
            models: response.data.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(`${type}/variants`)
        .then((response) => {
          this.setState({
            variants: response.data.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(`countries`)
        .then((response) => {
          this.setState({
            countries: response.data.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(`states`)
        .then((response) => {
          this.setState({
            states: response.data.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(`areas`)
        .then((response) => {
          this.setState({
            areas: response.data.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  selectMakesChangeHandler = (name, value) => {
    let updatedModels = [...this.state.models];
    updatedModels = updatedModels.filter((model) => {
      return model.vehicle_make_id === parseInt(value);
    });
    this.setState({
      filterdModels: updatedModels,
      filtredVariants: [],
      [`${name}`]: value,
    });
  };

  selectModelsChangedHandler = (name, value) => {
    let updatedVariants = [...this.state.variants];
    updatedVariants = updatedVariants.filter((variant) => {
      return variant.vehicle_model_id === parseInt(value);
    });
    this.setState({
      filtredVariants: updatedVariants,
      [`${name}`]: value,
    });
  };

  selectVariantsChangedHandler = (name, value) => {
    this.setState({
      [`${name}`]: value,
    });
  };

  selectCountryChangedHandler = (name, value) => {
    let updatedStates = [...this.state.states];
    updatedStates = updatedStates.filter((state) => {
      return state.country_id === parseInt(value);
    });
    this.setState({
      filterdStates: updatedStates,
      filterdAreas: [],
      [`${name}`]: value,
    });
  };

  selectStatesChangedHandler = (name, value) => {
    let updatedAreas = [...this.state.areas];
    updatedAreas = updatedAreas.filter((area) => {
      return area.state_id === parseInt(value);
    });
    this.setState({
      filterdAreas: updatedAreas,
      [`${name}`]: value,
    });
  };

  selectAreasChangedHandler = (name, value) => {
    this.setState({
      [`${name}`]: value,
    });
  };

  milageGenerators = () => {
    const milage = [0];
    const price = [2500];
    let milageValue = 0;
    let priceValue = 0;
    for (let mil = 0; mil < 30; mil++) {
      milageValue = milageValue + 50000;
      if (mil < 20) {
        priceValue = priceValue + 10000;
      } else {
        priceValue = priceValue + 100000;
      }
      milage.push(milageValue);
      price.push(priceValue);
    }
    this.setState({
      milageValues: milage,
      priceValues: price,
    });
  };

  // ############################################# EXISTED IMAGES HANDLER FOR EDIT POST #################:
  //##############################################
  ExistedImagesHandler = () => {
    if (this.props.postToEdit) {
      this.props.postToEdit.media.forEach((med) => {
        if (this.props.vihecleType === "cars" && med.name !== "video") {
          switch (med.name) {
            case "1":
              this.setState({ imgOneSrc: med.url });
              break;
            case "2":
              this.setState({ imgTowSrc: med.url });
              break;
            case "3":
              this.setState({ imgThreeSrc: med.url });
              break;
            case "4":
              this.setState({ imgFourSrc: med.url });
              break;
            case "5":
              this.setState({ imgFiveSrc: med.url });
              break;
            case "6":
              this.setState({ imgSixSrc: med.url });
              break;
            case "7":
              this.setState({ imgSevenSrc: med.url });
              break;
            case "8":
              this.setState({ imgEghitSrc: med.url });
              break;
            case "9":
              this.setState({ imgNineSrc: med.url });
              break;
            case "10":
              this.setState({ imgTenSrc: med.url });
              break;
            case "11":
              this.setState({ imgElevenSrc: med.url });
              break;
            case "12":
              this.setState({ imgTwelvSrc: med.url });
              break;
            case "13":
              this.setState({ optinalOneSrc: med.url });
              break;
            case "14":
              this.setState({ optinaltwoSrc: med.url });
              break;
            case "15":
              this.setState({ optinalThreeSrc: med.url });
              break;
            case "16":
              this.setState({ optinalFourSrc: med.url });
              break;
            case "17":
              this.setState({ optinalFiveSrc: med.url });
              break;
            case "18":
              this.setState({ optinalSixSrc: med.url });
              break;
            case "19":
              this.setState({ optinalSevenSrc: med.url });
              break;
            case "20":
              this.setState({ optinalEeightSrc: med.url });
              break;
            case "21":
              this.setState({ optinalNineSrc: med.url });
              break;
            case "22":
              this.setState({ optinalElevenSrc: med.url });
              break;
            case "23":
              this.setState({ optinalTwelevSrc: med.url });
              break;
            case "24":
              this.setState({ optinalThirteenSrc: med.url });
              break;
            default:
              break;
          }
        }
        if (this.props.vihecleType !== "cars" && med.name !== "video") {
          switch (med.name) {
            case "1":
              this.setState({ imgOneSrc: med.url });
              break;
            case "2":
              this.setState({ imgTowSrc: med.url });
              break;
            case "3":
              this.setState({ imgThreeSrc: med.url });
              break;
            case "4":
              this.setState({ imgFourSrc: med.url });
              break;
            case "5":
              this.setState({ imgFiveSrc: med.url });
              break;
            case "6":
              this.setState({ imgSixSrc: med.url });
              break;
            case "7":
              this.setState({ optinalOneSrc: med.url });
              break;
            case "8":
              this.setState({ optinaltwoSrc: med.url });
              break;
            case "9":
              this.setState({ optinalThreeSrc: med.url });
              break;
            case "10":
              this.setState({ optinalFourSrc: med.url });
              break;
            case "11":
              this.setState({ optinalFiveSrc: med.url });
              break;
            case "12":
              this.setState({ optinalSixSrc: med.url });
              break;
            case "13":
              this.setState({ optinalSevenSrc: med.url });
              break;
            case "14":
              this.setState({ optinalEeightSrc: med.url });
              break;
            case "15":
              this.setState({ optinalNineSrc: med.url });
              break;
            case "16":
              this.setState({ optinalElevenSrc: med.url });
              break;
            case "17":
              this.setState({ optinalTwelevSrc: med.url });
              break;
            case "18":
              this.setState({ optinalThirteenSrc: med.url });
              break;
            default:
              break;
          }
        }
      });
    }
  };

  // #################################################################
  // ################################################################ FORM METHODS :

  setCoordinateHandler = (coords) => {
    this.setState({ coords: coords });
  };

  inputChangeHandler = (name, value) => {
    this.setState({
      [`${name}`]: value,
    });
  };

  restFormHandler = () => {
    this.setState({
      vehicleCondition: "",
      bodyType: "",
      transmission: "",
      drivenWheel: "",
      fuelType: "",
      vehicle_make_id: "",
      vehicle_model_id: "",
      vehicle_variant_id: "",
      year_of_manufacture: "",
      Price: "",
      Milage: "",
      country_id: "",
      state_id: "",
      area_id: "",
    });
    //window.location.reload(false)
    // this.props.reLoadCompnent()
    // this.props.onGetVehicleItems(localStorage.getItem('vehicleType'))
  };

  formSubmitHandler = (event) => {
    event.preventDefault();
    const valuesArray = [];
    const errorArray = [];
    valuesArray.push(
      { Title: this.state.title },
      { "Seller Pitch": this.state.sellerPitch },
      { Condition: this.state.vehicleCondition },
      { "body Type": this.state.bodyType },
      {
        Transmission:
          this.props.vihecleType === "motors"
            ? "Ignore"
            : this.state.transmission,
      },
      {
        "Driven wheel":
          this.props.vihecleType !== "cars" ? "Ignore" : this.state.drivenWheel,
      },
      { "Fuel Type": this.state.fuelType },
      { "Make/Brand": this.state.vehicle_make_id },
      { Model: this.state.vehicle_model_id },
      { Variant: this.state.vehicle_variant_id },
      { "Manufacturing Year": this.state.year_of_manufacture },
      { Price: this.state.Price },
      { Milage: this.state.Milage },
      { Country: this.state.country_id },
      { State: this.state.state_id },
      { Area: this.state.area_id },
      {
        "Image One": this.state.imgOne.editedImgSrc
          ? this.state.imgOne.editedImgSrc
          : this.state.imgOneSrc,
      },
      {
        "Image Tow": this.state.imgTow.editedImgSrc
          ? this.state.imgTow.editedImgSrc
          : this.state.imgTowSrc,
      },
      {
        "Image Three": this.state.imgThree.editedImgSrc
          ? this.state.imgThree.editedImgSrc
          : this.state.imgThreeSrc,
      },
      {
        "Image Four": this.state.imgFour.editedImgSrc
          ? this.state.imgFour.editedImgSrc
          : this.state.imgFourSrc,
      },
      {
        "Image Five": this.state.imgFive.editedImgSrc
          ? this.state.imgFive.editedImgSrc
          : this.state.imgFiveSrc,
      },
      {
        "Image Six": this.state.imgSix.editedImgSrc
          ? this.state.imgSix.editedImgSrc
          : this.state.imgSixSrc,
      },
      {
        "Image Seven":
          this.props.vihecleType === "cars"
            ? this.state.imgSeven.editedImgSrc
              ? this.state.imgSeven.editedImgSrc
              : this.state.imgSevenSrc
            : carimgSeven,
      },
      {
        "Image Eghit":
          this.props.vihecleType === "cars"
            ? this.state.imgEghit.editedImgSrc
              ? this.state.imgEghit.editedImgSrc
              : this.state.imgEghitSrc
            : carimgEghit,
      },
      {
        "Image Nine":
          this.props.vihecleType === "cars"
            ? this.state.imgNine.editedImgSrc
              ? this.state.imgNine.editedImgSrc
              : this.state.imgNineSrc
            : carimgNine,
      },
      {
        "Image Ten":
          this.props.vihecleType === "cars"
            ? this.state.imgTen.editedImgSrc
              ? this.state.imgTen.editedImgSrc
              : this.state.imgTenSrc
            : carimgTen,
      },
      {
        "Image Eleven":
          this.props.vihecleType === "cars"
            ? this.state.imgEleven.editedImgSrc
              ? this.state.imgEleven.editedImgSrc
              : this.state.imgElevenSrc
            : carimgEleven,
      },
      {
        "Image Twelv":
          this.props.vihecleType === "cars"
            ? this.state.imgTwelv.editedImgSrc
              ? this.state.imgTwelv.editedImgSrc
              : this.state.imgTwelvSrc
            : carimgTwelv,
      }
    );
    valuesArray.map((ele) => {
      return Object.entries(ele).map((val) => {
        if (typeof val[1] === "string") {
          if (val[1].trim() === "") {
            errorArray.push(val[0]);
          } else {
            // console.log(val[0], val[1])
          }
        } else if (!val[1]) {
          errorArray.push(val[0]);
        }
        return errorArray;
      });
    });
    window.scrollTo(0, 0);
    const errorMess =
      "Please provid values for the following fields :\n" +
      errorArray.join("\n");
    // console.log(errorArray)
    // console.log(errorMess)
    if (errorArray.length > 0) {
      this.props.errorModalHandler(errorMess);
    } else {
      this.searchUrlConstructor(
        this.state.title,
        this.state.sellerPitch,
        this.state.vehicleCondition,
        this.state.bodyType,
        this.state.transmission,
        this.state.drivenWheel,
        this.state.fuelType,
        this.state.vehicle_make_id,
        this.state.vehicle_model_id,
        this.state.vehicle_variant_id,
        this.state.year_of_manufacture,
        this.state.Price,
        this.state.Milage,
        this.state.country_id,
        this.state.state_id,
        this.state.area_id,
        this.state.imgOne.editedImgSrc,
        this.state.imgTow.editedImgSrc,
        this.state.imgThree.editedImgSrc,
        this.state.imgFour.editedImgSrc,
        this.state.imgFive.editedImgSrc,
        this.state.imgSix.editedImgSrc,
        this.state.imgSeven.editedImgSrc,
        this.state.imgEghit.editedImgSrc,
        this.state.imgNine.editedImgSrc,
        this.state.imgTen.editedImgSrc,
        this.state.imgEleven.editedImgSrc,
        this.state.imgTwelv.editedImgSrc,
        this.state.video.editedVidType,
        this.state.optinalOne.editedImgSrc,
        this.state.optinaltwo.editedImgSrc,
        this.state.optinalThree.editedImgSrc,
        this.state.optinalFour.editedImgSrc,
        this.state.optinalFive.editedImgSrc,
        this.state.optinalSix.editedImgSrc,
        this.state.optinalSeven.editedImgSrc,
        this.state.optinalEeight.editedImgSrc,
        this.state.optinalNine.editedImgSrc,
        this.state.optinalEleven.editedImgSrc,
        this.state.optinalTwelev.editedImgSrc,
        this.state.optinalThirteen.editedImgSrc
      );
    }
  };

  searchUrlConstructor = (
    title,
    seller_pitch,
    condition,
    bodyType,
    transmission,
    drivenWheel,
    fuelType,
    vehicle_make_id,
    vehicle_model_id,
    vehicle_variant_id,
    year_of_manufacture,
    Price,
    Milage,
    country_id,
    state_id,
    area_id,
    imgOne,
    imgTow,
    imgThree,
    imgFour,
    imgFive,
    imgSix,
    imgSeven,
    imgEghit,
    imgNine,
    imgTen,
    imgEleven,
    imgTwelv,
    video,
    optinalOne,
    optinaltwo,
    optinalThree,
    optinalFour,
    optinalFive,
    optinalSix,
    optinalSeven,
    optinalEeight,
    optinalNine,
    optinalEleven,
    optinalTwelev,
    optinalThirteen
  ) => {
    const vehicleType = this.props.vihecleType;

    let media = [],
      vidMedia = null,
      images = [
        imgOne,
        imgTow,
        imgThree,
        imgFour,
        imgFive,
        imgSix,
        imgSeven,
        imgEghit,
        imgNine,
        imgTen,
        imgEleven,
        imgTwelv,
      ],
      optinal = [
        optinalOne,
        optinaltwo,
        optinalThree,
        optinalFour,
        optinalFive,
        optinalSix,
        optinalSeven,
        optinalEeight,
        optinalNine,
        optinalEleven,
        optinalTwelev,
        optinalThirteen,
      ],
      optinalStart = 13;

    if (vehicleType !== "cars") {
      images = [imgOne, imgTow, imgThree, imgFour, imgFive, imgSix];
      optinalStart = 7;
    }

    images.forEach((img, i) => {
      media.push({
        name: (i + 1).toString(),
        content: img ? img : null,
      });
    });

    if (video) {
      // media.push({
      //     name: "video",
      //     content: video
      // })
      vidMedia = {
        name: "video",
        content: video,
      };
    }
    optinal.forEach((optImg, i) => {
      if (optImg) {
        media.push({
          name: (i + optinalStart).toString(),
          content: optImg,
        });
      }
    });
    const data = {
      title: title,
      seller_pitch: seller_pitch,
      condition: condition,
      body_type: bodyType,
      transmission: transmission,
      driven_wheel: drivenWheel,
      fuel_type: fuelType,
      vehicle_make_id: vehicle_make_id,
      vehicle_model_id: vehicle_model_id,
      vehicle_variant_id: vehicle_variant_id,
      year_of_manufacture: year_of_manufacture,
      price: Price,
      mileage: Milage,
      country_id: country_id,
      state_id: state_id,
      area_id: area_id,
      media: media,
      is_published: 0,
      ...this.state.coords,
    };
    let mediaData = {
      media: media,
    };
    if (this.props.postToEdit) {
      media = media.filter((item) => item.content !== null);
      // this.props.postToEdit.media.forEach(img=>{
      //     console.log(img)
      //     media.forEach(item=>{
      //         if(item.name === img.name){
      //             item.id = img.id
      //         }
      //     })
      // })
      mediaData.media = media;
      delete data.media;
      const postId = localStorage.getItem("draftId");
      if (mediaData.media.length) {
        this.props.onSaveEditedPost(
          this.props.vihecleType,
          postId,
          data,
          mediaData,
          vidMedia
        );
      } else {
        this.props.onSaveEditedPost(
          this.props.vihecleType,
          postId,
          data,
          null,
          vidMedia
        );
      }
    } else {
      this.props.onSendPostAsDraft(
        this.props.vihecleType,
        data,
        mediaData,
        vidMedia
      );
    }
    this.props.history.push("/Preview");
  };

  // ################################################# IMAGE HANLDERS METHODS :

  inputName = "imgOne";

  uploadImageHandler = (event) => {
    this.inputName = event.target.name;
    const file = event.target.files.item(0);
    let reader = new FileReader();
    let base46Img = null;
    const ImgTypes = ["image/jpeg", "image/png", "image/gif"];
    const validType = ImgTypes.some((type) => {
      if (file) {
        return file.type === type;
      } else return null;
    });
    const currentImgUpdate = { ...this.state[`${this.inputName}`] };

    if (validType) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        base46Img = reader.result;
        currentImgUpdate.imgEdited = true;
        currentImgUpdate.editedImgSrc = base46Img;
        this.setState({
          [`${this.inputName}`]: currentImgUpdate,
          imageIsntTouched: false,
        });
        this.setState({ [`${this.inputName}Src`]: base46Img });
      };
    }
  };

  removeImgHandler = (name) => {
    const curentImg = { ...this.state[`${name}`] };
    if (curentImg.editedImgSrc) {
      curentImg.editedImgSrc = null;
      curentImg.imgEdited = false;
      this.setState({
        [`${name}`]: curentImg,
      });
    }
  };
  //Upload All:
  stateImgFinder = (numb) => {
    switch (numb) {
      case 0:
        return "imgOne";
      case 1:
        return "imgTow";
      case 2:
        return "imgThree";
      case 3:
        return "imgFour";
      case 4:
        return "imgFive";
      case 5:
        return "imgSix";
      case 6:
        return "imgSeven";
      case 7:
        return "imgEghit";
      case 8:
        return "imgNine";
      case 9:
        return "imgTen";
      case 10:
        return "imgEleven";
      case 11:
        return "imgTwelv";
      default:
        return null;
    }
  };

  uploadAllHAndler = (event) => {
    let files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      if (i > 11) {
        break;
      } else {
        let file = files[i];
        // Make new FileReader
        let reader = new FileReader();
        let base46Img = null;
        let stateImg = this.stateImgFinder(i);
        const ImgTypes = ["image/jpeg", "image/png", "image/gif"];
        const validType = ImgTypes.some((type) => {
          if (file) {
            return file.type === type;
          } else return null;
        });
        const currentImgUpdate = { ...this.state[`${stateImg}`] };

        if (validType) {
          reader.readAsDataURL(file);
          reader.onload = () => {
            base46Img = reader.result;
            currentImgUpdate.imgEdited = true;
            currentImgUpdate.editedImgSrc = base46Img;
            this.setState({
              [`${stateImg}`]: currentImgUpdate,
              imageIsntTouched: false,
            });
            this.setState({ [`${stateImg}Src`]: base46Img });
          };
        }
      }
    }
  };

  //####################################################################################
  // ######################################################################### RENDER:
  //####################################################################################

  render() {
    const VideoWraperClasses = this.state.showVideos
      ? `${classes.VideoWraper}`
      : `${classes.Hide}`;
    const ImgWraperClasses = this.state.showImages
      ? `${classes.ImgWraper}`
      : `${classes.Hide}`;
    const formOptionsClasses = this.state.showTechnical
      ? `${classes.formOptions}`
      : `${classes.Hide}`;
    let imgOne = null,
      imgTow = null,
      imgThree = null,
      imgFour = null,
      imgFive = null,
      imgSix = null,
      imgSeven = null,
      imgEghit = null,
      imgNine = null,
      imgTen = null,
      imgEleven = null,
      imgTwelv = null,
      videoSrc = null,
      optinalOneSrc = null,
      optinaltwoSrc = null,
      optinalThreeSrc = null,
      optinalFourSrc = null,
      optinalFiveSrc = null,
      optinalSixSrc = null,
      optinalSevenSrc = null,
      optinalEeightSrc = null,
      optinalNineSrc = null,
      optinalElevenSrc = null,
      optinalTwelevSrc = null,
      optinalThirteenSrc = null;

    if (this.props.vihecleType === "cars") {
      imgOne = (
        <img
          src={
            this.state.imgOne.imgEdited
              ? this.state.imgOne.editedImgSrc
              : carimgOne
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgTow = (
        <img
          src={
            this.state.imgTow.imgEdited
              ? this.state.imgTow.editedImgSrc
              : carimgTow
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgThree = (
        <img
          src={
            this.state.imgThree.imgEdited
              ? this.state.imgThree.editedImgSrc
              : carimgThree
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgFour = (
        <img
          src={
            this.state.imgFour.imgEdited
              ? this.state.imgFour.editedImgSrc
              : carimgFour
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgFive = (
        <img
          src={
            this.state.imgFive.imgEdited
              ? this.state.imgFive.editedImgSrc
              : carimgFive
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgSix = (
        <img
          src={
            this.state.imgSix.imgEdited
              ? this.state.imgSix.editedImgSrc
              : carimgSix
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgSeven = (
        <img
          src={
            this.state.imgSeven.imgEdited
              ? this.state.imgSeven.editedImgSrc
              : carimgSeven
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgEghit = (
        <img
          src={
            this.state.imgEghit.imgEdited
              ? this.state.imgEghit.editedImgSrc
              : carimgEghit
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgNine = (
        <img
          src={
            this.state.imgNine.imgEdited
              ? this.state.imgNine.editedImgSrc
              : carimgNine
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgTen = (
        <img
          src={
            this.state.imgTen.imgEdited
              ? this.state.imgTen.editedImgSrc
              : carimgTen
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgEleven = (
        <img
          src={
            this.state.imgEleven.imgEdited
              ? this.state.imgEleven.editedImgSrc
              : carimgEleven
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgTwelv = (
        <img
          src={
            this.state.imgTwelv.imgEdited
              ? this.state.imgTwelv.editedImgSrc
              : carimgTwelv
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
    } else if (this.props.vihecleType === "motors") {
      imgOne = (
        <img
          src={
            this.state.imgOne.imgEdited
              ? this.state.imgOne.editedImgSrc
              : motorOne
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgTow = (
        <img
          src={
            this.state.imgTow.imgEdited
              ? this.state.imgTow.editedImgSrc
              : motorTow
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgThree = (
        <img
          src={
            this.state.imgThree.imgEdited
              ? this.state.imgThree.editedImgSrc
              : motorThree
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgFour = (
        <img
          src={
            this.state.imgFour.imgEdited
              ? this.state.imgFour.editedImgSrc
              : motorFour
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgFive = (
        <img
          src={
            this.state.imgFive.imgEdited
              ? this.state.imgFive.editedImgSrc
              : motorFive
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgSix = (
        <img
          src={
            this.state.imgSix.imgEdited
              ? this.state.imgSix.editedImgSrc
              : motorSix
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      // imgSeven = <img src={this.state.imgSeven.editedImgSrc} alt='Profile pic' width='70px' height='70px' />;
      // imgEghit = <img src={this.state.imgEghit.editedImgSrc} alt='Profile pic' width='70px' height='70px' />;
      // imgNine = <img src={this.state.imgNine.editedImgSrc} alt='Profile pic' width='70px' height='70px' />;
      // imgTen = <img src={this.state.imgTen.editedImgSrc} alt='Profile pic' width='70px' height='70px' />;
      // imgEleven = <img src={this.state.imgEleven.editedImgSrc} alt='Profile pic' width='70px' height='70px' />;
      // imgTwelv = <img src={this.state.imgTwelv.editedImgSrc} alt='Profile pic' width='70px' height='70px' />;
    } else if (this.props.vihecleType === "commercials") {
      imgOne = (
        <img
          src={
            this.state.imgOne.editedImgSrc
              ? this.state.imgOne.editedImgSrc
              : commercialOne
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgTow = (
        <img
          src={
            this.state.imgTow.editedImgSrc
              ? this.state.imgTow.editedImgSrc
              : commercialTwo
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgThree = (
        <img
          src={
            this.state.imgThree.editedImgSrc
              ? this.state.imgThree.editedImgSrc
              : commercialThree
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgFour = (
        <img
          src={
            this.state.imgFour.editedImgSrc
              ? this.state.imgFour.editedImgSrc
              : carimgSeven
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgFive = (
        <img
          src={
            this.state.imgFive.editedImgSrc
              ? this.state.imgFive.editedImgSrc
              : carimgEghit
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      imgSix = (
        <img
          src={
            this.state.imgSix.editedImgSrc
              ? this.state.imgSix.editedImgSrc
              : carimgNine
          }
          alt="Profile pic"
          width="70px"
          height="70px"
        />
      );
      // imgSeven = <img src={this.state.imgSeven.editedImgSrc ? this.state.imgSeven.editedImgSrc: commercialOne} alt='Profile pic' width='70px' height='70px' />;
      // imgEghit = <img src={this.state.imgEghit.editedImgSrc ? this.state.imgEghit.editedImgSrc: commercialOne} alt='Profile pic' width='70px' height='70px' />;
      // imgNine = <img src={this.state.imgNine.editedImgSrc ? this.state.imgNine.editedImgSrc: commercialOne} alt='Profile pic' width='70px' height='70px' />;
      // imgTen = <img src={this.state.imgTen.editedImgSrc ? this.state.imgTen.editedImgSrc: commercialOne} alt='Profile pic' width='70px' height='70px' />;
      // imgEleven = <img src={this.state.imgEleven.editedImgSrc ? this.state.imgEleven.editedImgSrc: commercialOne} alt='Profile pic' width='70px' height='70px' />;
      // imgTwelv = <img src={this.state.imgTwelv.editedImgSrc ? this.state.imgTwelv.editedImgSrc: commercialOne} alt='Profile pic' width='70px' height='70px' />;
    }
    if (this.props.postToEdit) {
      let imgOneSrc = null,
        imgTowSrc = null,
        imgThreeSrc = null,
        imgFourSrc = null,
        imgFiveSrc = null,
        imgSixSrc = null,
        imgSevenSrc = null,
        imgEghitSrc = null,
        imgNineSrc = null,
        imgTenSrc = null,
        imgElevenSrc = null,
        imgTwelvSrc = null;

      videoSrc = this.props.postToEdit.media.filter((med) => {
        if (this.props.vihecleType === "cars" && med.name !== "video") {
          switch (med.name) {
            case "1":
              imgOneSrc = med.url;
              break;
            case "2":
              imgTowSrc = med.url;
              break;
            case "3":
              imgThreeSrc = med.url;
              break;
            case "4":
              imgFourSrc = med.url;
              break;
            case "5":
              imgFiveSrc = med.url;
              break;
            case "6":
              imgSixSrc = med.url;
              break;
            case "7":
              imgSevenSrc = med.url;
              break;
            case "8":
              imgEghitSrc = med.url;
              break;
            case "9":
              imgNineSrc = med.url;
              break;
            case "10":
              imgTenSrc = med.url;
              break;
            case "11":
              imgElevenSrc = med.url;
              break;
            case "12":
              imgTwelvSrc = med.url;
              break;
            case "13":
              optinalOneSrc = med.url;
              break;
            case "14":
              optinaltwoSrc = med.url;
              break;
            case "15":
              optinalThreeSrc = med.url;
              break;
            case "16":
              optinalFourSrc = med.url;
              break;
            case "17":
              optinalFiveSrc = med.url;
              break;
            case "18":
              optinalSixSrc = med.url;
              break;
            case "19":
              optinalSevenSrc = med.url;
              break;
            case "20":
              optinalEeightSrc = med.url;
              break;
            case "21":
              optinalNineSrc = med.url;
              break;
            case "22":
              optinalElevenSrc = med.url;
              break;
            case "23":
              optinalTwelevSrc = med.url;
              break;
            case "24":
              optinalThirteenSrc = med.url;
              break;
            default:
              break;
          }
        }
        if (this.props.vihecleType !== "cars" && med.name !== "video") {
          switch (med.name) {
            case "1":
              imgOneSrc = med.url;
              break;
            case "2":
              imgTowSrc = med.url;
              break;
            case "3":
              imgThreeSrc = med.url;
              break;
            case "4":
              imgFourSrc = med.url;
              break;
            case "5":
              imgFiveSrc = med.url;
              break;
            case "6":
              imgSixSrc = med.url;
              break;
            case "7":
              optinalOneSrc = med.url;
              break;
            case "8":
              optinaltwoSrc = med.url;
              break;
            case "9":
              optinalThreeSrc = med.url;
              break;
            case "10":
              optinalFourSrc = med.url;
              break;
            case "11":
              optinalFiveSrc = med.url;
              break;
            case "12":
              optinalSixSrc = med.url;
              break;
            case "13":
              optinalSevenSrc = med.url;
              break;
            case "14":
              optinalEeightSrc = med.url;
              break;
            case "15":
              optinalNineSrc = med.url;
              break;
            case "16":
              optinalElevenSrc = med.url;
              break;
            case "17":
              optinalTwelevSrc = med.url;
              break;
            case "18":
              optinalThirteenSrc = med.url;
              break;
            default:
              break;
          }
        }
        return med.name === "video";
      });
      try {
        videoSrc = videoSrc[0].url;
      } catch {
        videoSrc = null;
      }
      if (
        this.props.vihecleType === "cars" ||
        this.props.vihecleType === "car"
      ) {
        imgOne = (
          <img
            src={imgOneSrc ? this.state.imgOneSrc : carimgOne}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgTow = (
          <img
            src={imgTowSrc ? this.state.imgTowSrc : carimgTow}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgThree = (
          <img
            src={imgThreeSrc ? this.state.imgThreeSrc : carimgThree}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgFour = (
          <img
            src={imgFourSrc ? this.state.imgFourSrc : carimgFour}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgFive = (
          <img
            src={imgFiveSrc ? this.state.imgFiveSrc : carimgFive}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgSix = (
          <img
            src={imgSixSrc ? this.state.imgSixSrc : carimgSix}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgSeven = (
          <img
            src={imgSevenSrc ? this.state.imgSevenSrc : carimgSeven}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgEghit = (
          <img
            src={imgEghitSrc ? this.state.imgEghitSrc : carimgEghit}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgNine = (
          <img
            src={imgNineSrc ? this.state.imgNineSrc : carimgNine}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgTen = (
          <img
            src={imgTenSrc ? this.state.imgTenSrc : carimgTen}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgEleven = (
          <img
            src={imgElevenSrc ? this.state.imgElevenSrc : carimgEleven}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgTwelv = (
          <img
            src={imgTwelvSrc ? this.state.imgTwelvSrc : carimgTwelv}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
      }
      if (
        this.props.vihecleType === "motors" ||
        this.props.vihecleType === "motor"
      ) {
        imgOne = (
          <img
            src={imgOneSrc ? this.state.imgOneSrc : motorOne}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgTow = (
          <img
            src={imgTowSrc ? this.state.imgTowSrc : motorTow}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgThree = (
          <img
            src={imgThreeSrc ? this.state.imgThreeSrc : motorThree}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgFour = (
          <img
            src={imgFourSrc ? this.state.imgFourSrc : motorFour}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgFive = (
          <img
            src={imgFiveSrc ? this.state.imgFiveSrc : motorFive}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgSix = (
          <img
            src={imgSixSrc ? this.state.imgSixSrc : motorSix}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
      }
      if (
        this.props.vihecleType === "commercial" ||
        this.props.vihecleType === "commercials"
      ) {
        imgOne = (
          <img
            src={imgOneSrc ? this.state.imgOneSrc : commercialOne}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgTow = (
          <img
            src={imgTowSrc ? this.state.imgTowSrc : commercialTwo}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgThree = (
          <img
            src={imgThreeSrc ? this.state.imgThreeSrc : commercialThree}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgFour = (
          <img
            src={imgFourSrc ? this.state.imgFourSrc : carimgSeven}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgFive = (
          <img
            src={imgFiveSrc ? this.state.imgFiveSrc : carimgEghit}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
        imgSix = (
          <img
            src={imgSixSrc ? this.state.imgSixSrc : carimgNine}
            alt="Profile pic"
            width="70px"
            height="70px"
          />
        );
      }
    }
    if (this.state[`${this.inputName}`].imgEdited) {
      switch (this.inputName) {
        case "imgOne":
          imgOne = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgTow":
          imgTow = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgThree":
          imgThree = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgFour":
          imgFour = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgFive":
          imgFive = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgSix":
          imgSix = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgSeven":
          imgSeven = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgEghit":
          imgEghit = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgNine":
          imgNine = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgTen":
          imgTen = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgEleven":
          imgEleven = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        case "imgTwelv":
          imgTwelv = (
            <img
              src={this.state[`${this.inputName}`].editedImgSrc}
              alt="Profile pic"
              width="70px"
              height="70px"
            />
          );
          break;
        default:
          break;
      }
    }
    //####################################################################################
    //#################################################################################### RETURN :
    //####################################################################################

    return (
      <div className={classes.SearchOptions}>
        {/*#################################################################################### VIDEOS */}

        <div
          className={classes.SectionToggler}
          onClick={(event) => {
            this.toggelShowSection("showVideos");
          }}
        >
          <h2>
            <img src={toggeList} alt="toggel" />
            Upload your listing video.{" "}
          </h2>
          <p className={classes.underTitle}>
            Listings with video is proven to sell faster
          </p>
        </div>
        <div className={VideoWraperClasses}>
          <div className={classes.ProfilePic}>
            {/* <p>Video</p> */}
            <video
              controlsList="nodownload"
              controls
              src={
                this.state.video.editedVidSrc
                  ? this.state.video.editedVidSrc
                  : this.props.postToEdit
                  ? videoSrc
                  : null
              }
            >
              Sorry, your browser doesn't support embedded videos.
            </video>
            <label>
              <input
                type="file"
                name="video"
                onChange={(event) => {
                  const name = event.target.name;
                  const file = event.target.files.item(0);
                  let reader = new FileReader();
                  let base46Img = null;
                  const ImgTypes = [
                    "video/mp4",
                    "video/mkv",
                    "video/flv",
                    "video/mov",
                    "video/wmv",
                    "video/avi",
                    "video/avchd",
                    "video/webm",
                  ];
                  const currentImgUpdate = { ...this.state[`${name}`] };
                  const validType = ImgTypes.some((type) => {
                    if (file) {
                      return file.type === type;
                    } else return null;
                  });
                  if (validType && file.size < 100 * 1000000) {
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                      base46Img = reader.result;
                      currentImgUpdate.vidEdited = true;
                      currentImgUpdate.editedVidSrc = base46Img;
                      currentImgUpdate.editedVidType = file;
                      this.setState({ [`${name}`]: currentImgUpdate });
                    };
                  }
                }}
              />
              Upload
            </label>
          </div>
        </div>

        {/*#################################################################################### IMAGES */}
        <div
          className={classes.SectionToggler}
          onClick={(event) => {
            this.toggelShowSection("showImages");
          }}
        >
          <h2 className="mt-5">
            <img src={toggeList} alt="toggel" />
            Upload your listing images{" "}
          </h2>
          <p className={classes.underTitle}>
            We have provided you with a recommended photo styles to help you
            sell faster.
          </p>
        </div>
        <div className={ImgWraperClasses}>
          <div className={classes.UploadAll}>
            <p className={classes.underTitle}>
              Select Multiple picture altogether at once
            </p>
            <label>
              <input
                type="file"
                name="uploadAll"
                multiple
                onChange={(event) => this.uploadAllHAndler(event)}
              />
              Bulk Upload
            </label>
          </div>
          <div className={classes.ProfilePic}>
            <p>Front side</p>
            {imgOne}
            <label>
              <input
                type="file"
                name="imgOne"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
          </div>
          <div className={classes.ProfilePic}>
            <p>Back side</p>
            {imgTow}
            <label>
              <input
                type="file"
                name="imgTow"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
          </div>
          <div className={classes.ProfilePic}>
            <p>Side</p>
            {imgThree}
            <label>
              <input
                type="file"
                name="imgThree"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
          </div>
          <div className={classes.ProfilePic}>
            <p>
              {this.props.vihecleType !== "commercials" ? "Front" : "Mileage"}
            </p>
            {imgFour}
            <label>
              <input
                type="file"
                name="imgFour"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
          </div>
          <div className={classes.ProfilePic}>
            <p>{this.props.vihecleType !== "commercials" ? "Back" : "Gear"}</p>
            {imgFive}
            <label>
              <input
                type="file"
                name="imgFive"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
          </div>
          <div className={classes.ProfilePic}>
            <p>
              {this.props.vihecleType === "cars"
                ? "Tire"
                : this.props.vihecleType === "motors"
                ? "Mileage"
                : "Engine"}
            </p>
            {imgSix}
            <label>
              <input
                type="file"
                name="imgSix"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
          </div>
          {this.props.vihecleType === "cars" && (
            <Fragment>
              <div className={classes.ProfilePic}>
                <p>Milage</p>
                {imgSeven}
                <label>
                  <input
                    type="file"
                    name="imgSeven"
                    onChange={(event) => {
                      this.uploadImageHandler(event);
                    }}
                  />
                  Upload
                </label>
              </div>
              <div className={classes.ProfilePic}>
                <p>Gear</p>
                {imgEghit}
                <label>
                  <input
                    type="file"
                    name="imgEghit"
                    onChange={(event) => {
                      this.uploadImageHandler(event);
                    }}
                  />
                  Upload
                </label>
              </div>
              <div className={classes.ProfilePic}>
                <p>Engine</p>
                {imgNine}
                <label>
                  <input
                    type="file"
                    name="imgNine"
                    onChange={(event) => {
                      this.uploadImageHandler(event);
                    }}
                  />
                  Upload
                </label>
              </div>
              <div className={classes.ProfilePic}>
                <p>Front interior</p>
                {imgTen}
                <label>
                  <input
                    type="file"
                    name="imgTen"
                    onChange={(event) => {
                      this.uploadImageHandler(event);
                    }}
                  />
                  Upload
                </label>
              </div>
              <div className={classes.ProfilePic}>
                <p>Front seat</p>
                {imgEleven}
                <label>
                  <input
                    type="file"
                    name="imgEleven"
                    onChange={(event) => {
                      this.uploadImageHandler(event);
                    }}
                  />
                  Upload
                </label>
              </div>
              <div className={classes.ProfilePic}>
                <p>Back seat</p>
                {imgTwelv}
                <label>
                  <input
                    type="file"
                    name="imgTwelv"
                    onChange={(event) => {
                      this.uploadImageHandler(event);
                    }}
                  />
                  Upload
                </label>
              </div>
            </Fragment>
          )}
          {/*####################################################################################### */}
          {/*#######################################     OPTINAL IMAGES             ################################################ */}
          {/*####################################################################################### */}
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalOne.editedImgSrc ? (
              <img src={this.state.optinalOne.editedImgSrc} alt="optinal" />
            ) : optinalOneSrc ? (
              <img src={optinalOneSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalOne"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalOne"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinaltwo.editedImgSrc ? (
              <img src={this.state.optinaltwo.editedImgSrc} alt="optinal" />
            ) : optinaltwoSrc ? (
              <img src={optinaltwoSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinaltwo"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinaltwo"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalThree.editedImgSrc ? (
              <img src={this.state.optinalThree.editedImgSrc} alt="optinal" />
            ) : optinalThreeSrc ? (
              <img src={optinalThreeSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalThree"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalThree"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalFour.editedImgSrc ? (
              <img src={this.state.optinalFour.editedImgSrc} alt="optinal" />
            ) : optinalFourSrc ? (
              <img src={optinalFourSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalFour"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalFour"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalFive.editedImgSrc ? (
              <img src={this.state.optinalFive.editedImgSrc} alt="optinal" />
            ) : optinalFiveSrc ? (
              <img src={optinalFiveSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalFive"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalFive"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalSix.editedImgSrc ? (
              <img src={this.state.optinalSix.editedImgSrc} alt="optinal" />
            ) : optinalSixSrc ? (
              <img src={optinalSixSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalSix"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalSix"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalSeven.editedImgSrc ? (
              <img src={this.state.optinalSeven.editedImgSrc} alt="optinal" />
            ) : optinalSevenSrc ? (
              <img src={optinalSevenSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalSeven"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalSeven"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalEeight.editedImgSrc ? (
              <img src={this.state.optinalEeight.editedImgSrc} alt="optinal" />
            ) : optinalEeightSrc ? (
              <img src={optinalEeightSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalEeight"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalEeight"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalNine.editedImgSrc ? (
              <img src={this.state.optinalNine.editedImgSrc} alt="optinal" />
            ) : optinalNineSrc ? (
              <img src={optinalNineSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalNine"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalNine"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalEleven.editedImgSrc ? (
              <img src={this.state.optinalEleven.editedImgSrc} alt="optinal" />
            ) : optinalElevenSrc ? (
              <img src={optinalElevenSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalEleven"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalEleven"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalTwelev.editedImgSrc ? (
              <img src={this.state.optinalTwelev.editedImgSrc} alt="optinal" />
            ) : optinalTwelevSrc ? (
              <img src={optinalTwelevSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalTwelev"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalTwelev"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
          <div className={classes.ProfilePic}>
            <p>Optional images :</p>
            {this.state.optinalThirteen.editedImgSrc ? (
              <img
                src={this.state.optinalThirteen.editedImgSrc}
                alt="optinal"
              />
            ) : optinalThirteenSrc ? (
              <img src={optinalThirteenSrc} alt="optinal" />
            ) : null}
            <label>
              <input
                type="file"
                name="optinalThirteen"
                onChange={(event) => {
                  this.uploadImageHandler(event);
                }}
              />
              Upload
            </label>
            <small
              className="optinalThirteen"
              onClick={(event) => {
                this.removeImgHandler(event.target.className);
              }}
            >
              Remove
            </small>
          </div>
        </div>

        {/*#################################################################################### */}
        {/*#################################################################################### FORM OPTION : */}
        {/*#################################################################################### */}
        <div
          ref={this.imgRef}
          className={classes.SectionToggler}
          onClick={(event) => {
            this.toggelShowSection("showTechnical");
          }}
        >
          <h2 className="mt-5">
            <img src={toggeList} alt="toggel" />
            Add you listing details
          </h2>
        </div>
        {this.props.vihecleType === "cars" ||
        this.props.vihecleType === "all" ||
        this.props.vihecleType === "motors" ||
        this.props.vihecleType === "commercials" ||
        this.props.postToEdit ? (
          <div className={formOptionsClasses}>
            <form
              onSubmit={(event) => {
                this.formSubmitHandler(event);
              }}
            >
              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Title</p>
                <input
                  ref={this.optionRef}
                  className={classes.textInput}
                  type="text"
                  placeholder="Title"
                  value={this.state.title}
                  onChange={(event) => {
                    this.setState({
                      title: event.target.value,
                    });
                  }}
                />
              </div>
              <p className="mt-3">Seller Pitch</p>
              <textarea
                // className={classes.textInput}
                placeholder="seller Pitch"
                value={this.state.sellerPitch}
                onChange={(event) => {
                  this.setState({
                    sellerPitch: event.target.value,
                  });
                }}
              />
              <p className="mt-3">Condition</p>
              <div className={classes.VehicleTypes}>
                {Object.values(CONDITION).map((condition) => {
                  return (
                    <Fragment key={condition}>
                      <input
                        value={`${condition}`}
                        type="radio"
                        name="vehicleCondition"
                        id={`${condition}`}
                        defaultChecked={
                          this.props.postToEdit
                            ? this.props.postToEdit.condition === condition
                              ? true
                              : false
                            : false
                        }
                        onChange={(event) => {
                          this.inputChangeHandler(
                            event.target.name,
                            event.target.value
                          );
                        }}
                      />
                      <label htmlFor={`${condition}`}>{condition}</label>
                    </Fragment>
                  );
                })}
              </div>
              <p className="mt-3">BODY TYPE</p>
              <div className={classes.BodyTypes}>
                {this.props.vihecleType === "cars" ||
                this.props.vihecleType === "car"
                  ? Object.values(BODY_TYPE).map((bodyT) => {
                      return (
                        <Fragment key={bodyT}>
                          <input
                            value={`${bodyT}`}
                            type="radio"
                            name="bodyType"
                            id={`${bodyT}`}
                            defaultChecked={
                              this.props.postToEdit
                                ? this.props.postToEdit.body_type === bodyT
                                  ? true
                                  : false
                                : false
                            }
                            onChange={(event) => {
                              this.inputChangeHandler(
                                event.target.name,
                                event.target.value
                              );
                            }}
                          />
                          <label
                            className={classes.SmallFont}
                            htmlFor={`${bodyT}`}
                          >
                            <img
                              src={ICONS[`${bodyT}`]}
                              alt={`${bodyT}`}
                              style={{ marginBottom: "6px" }}
                            />
                            {bodyT}
                          </label>
                        </Fragment>
                      );
                    })
                  : this.props.vihecleType === "motors" ||
                    this.props.vihecleType === "motor"
                  ? Object.values(MOTORS_BODY_TYPE).map((bodyT) => {
                      return (
                        <Fragment key={bodyT}>
                          <input
                            value={`${bodyT}`}
                            type="radio"
                            name="bodyType"
                            id={`${bodyT}`}
                            defaultChecked={
                              this.props.postToEdit
                                ? this.props.postToEdit.body_type === bodyT
                                  ? true
                                  : false
                                : false
                            }
                            onChange={(event) => {
                              this.inputChangeHandler(
                                event.target.name,
                                event.target.value
                              );
                            }}
                          />
                          <label
                            className={classes.SmallFont}
                            htmlFor={`${bodyT}`}
                          >
                            <img
                              src={ICONS[`${bodyT}`]}
                              alt={`${bodyT}`}
                              style={{ width: "40px", marginBottom: "6px" }}
                            />
                            {bodyT}
                          </label>
                        </Fragment>
                      );
                    })
                  : this.props.vihecleType === "commercials" ||
                    this.props.vihecleType === "commercial"
                  ? Object.values(COMMERCIALS_BODY_TYPE).map((bodyT) => {
                      return (
                        <Fragment key={bodyT}>
                          <input
                            value={`${bodyT}`}
                            type="radio"
                            name="bodyType"
                            id={`${bodyT}`}
                            defaultChecked={
                              this.props.postToEdit
                                ? this.props.postToEdit.body_type === bodyT
                                  ? true
                                  : false
                                : false
                            }
                            onChange={(event) => {
                              this.inputChangeHandler(
                                event.target.name,
                                event.target.value
                              );
                            }}
                          />
                          <label
                            className={classes.SmallFont}
                            htmlFor={`${bodyT}`}
                          >
                            <img
                              src={ICONS[`${bodyT}`]}
                              alt={`${bodyT}`}
                              style={{ marginBottom: "6px" }}
                              width="25px"
                            />
                            {bodyT}
                          </label>
                        </Fragment>
                      );
                    })
                  : null}
              </div>
              {this.props.vihecleType !== "motors" && (
                <Fragment>
                  <p className="mt-3">Transmission</p>
                  <div className={classes.BodyTypes}>
                    {Object.values(TRANSMISSION).map((tran) => {
                      return (
                        <Fragment key={tran}>
                          <input
                            value={tran}
                            type="radio"
                            name="transmission"
                            id={tran}
                            defaultChecked={
                              this.props.postToEdit
                                ? this.props.postToEdit.transmission === tran
                                  ? true
                                  : false
                                : false
                            }
                            onChange={(event) => {
                              this.inputChangeHandler(
                                event.target.name,
                                event.target.value
                              );
                            }}
                          />
                          <label htmlFor={tran}>
                            <img src={ICONS[`${tran}`]} alt={tran} />
                            {tran}
                          </label>
                        </Fragment>
                      );
                    })}
                  </div>
                </Fragment>
              )}

              {this.props.vihecleType === "cars" && (
                <Fragment>
                  <p className="mt-3">Driven Wheel</p>
                  <div className={classes.DrivenW}>
                    {Object.values(DREVIEN_WHEEL).map((dWheel) => {
                      return (
                        <Fragment key={dWheel}>
                          <input
                            value={dWheel}
                            type="radio"
                            name="drivenWheel"
                            id={dWheel}
                            defaultChecked={
                              this.props.postToEdit
                                ? this.props.postToEdit.driven_wheel === dWheel
                                  ? true
                                  : false
                                : false
                            }
                            onChange={(event) => {
                              this.inputChangeHandler(
                                event.target.name,
                                event.target.value
                              );
                            }}
                          />
                          <label htmlFor={dWheel}>{dWheel}</label>
                        </Fragment>
                      );
                    })}
                  </div>
                </Fragment>
              )}
              <p className="mt-3">Fuel Type</p>
              <div className={classes.BodyTypes}>
                {this.props.vihecleType === "cars" ||
                this.props.vihecleType === "car"
                  ? Object.values(FUEL_TYPE).map((fuelT) => {
                      return (
                        <Fragment key={fuelT}>
                          <input
                            value={fuelT}
                            type="radio"
                            name="fuelType"
                            id={fuelT}
                            defaultChecked={
                              this.props.postToEdit
                                ? this.props.postToEdit.fuel_type === fuelT
                                  ? true
                                  : false
                                : false
                            }
                            onChange={(event) => {
                              this.inputChangeHandler(
                                event.target.name,
                                event.target.value
                              );
                            }}
                          />
                          <label htmlFor={fuelT}>
                            <img src={ICONS[`${fuelT}`]} alt={fuelT} />
                            {fuelT}
                          </label>
                        </Fragment>
                      );
                    })
                  : this.props.vihecleType === "motors" ||
                    this.props.vihecleType === "motor"
                  ? Object.values(MOTORS_FUEL_TYPE).map((fuelT) => {
                      return (
                        <Fragment key={fuelT}>
                          <input
                            value={fuelT}
                            type="radio"
                            name="fuelType"
                            id={fuelT}
                            defaultChecked={
                              this.props.postToEdit
                                ? this.props.postToEdit.fuel_type === fuelT
                                  ? true
                                  : false
                                : false
                            }
                            onChange={(event) => {
                              this.inputChangeHandler(
                                event.target.name,
                                event.target.value
                              );
                            }}
                          />
                          <label htmlFor={fuelT}>
                            <img src={ICONS[`${fuelT}`]} alt={fuelT} />
                            {fuelT}
                          </label>
                        </Fragment>
                      );
                    })
                  : this.props.vihecleType === "commercials" ||
                    this.props.vihecleType === "commercial"
                  ? Object.values(COMMERCIALS_FUEL_TYPE).map((fuelT) => {
                      return (
                        <Fragment key={fuelT}>
                          <input
                            value={fuelT}
                            type="radio"
                            name="fuelType"
                            id={fuelT}
                            defaultChecked={
                              this.props.postToEdit
                                ? this.props.postToEdit.fuel_type === fuelT
                                  ? true
                                  : false
                                : false
                            }
                            onChange={(event) => {
                              this.inputChangeHandler(
                                event.target.name,
                                event.target.value
                              );
                            }}
                          />
                          <label htmlFor={fuelT}>
                            <img src={ICONS[`${fuelT}`]} alt={fuelT} />
                            {fuelT}
                          </label>
                        </Fragment>
                      );
                    })
                  : null}
              </div>
              <div className={classes.SelectNinputWraper}>
                <div className={classes.SearchNinputElementWraper}>
                  <p className="mt-3">Make</p>
                  <select
                    name="vehicle_make_id"
                    onChange={(event) => {
                      this.selectMakesChangeHandler(
                        event.target.name,
                        event.target.value
                      );
                    }}
                  >
                    <option
                      value={
                        this.props.postToEdit
                          ? this.props.postToEdit.vehicle_make.id
                          : ""
                      }
                    >
                      {this.props.postToEdit
                        ? this.props.postToEdit.vehicle_make.name
                        : "Make / Brands"}
                    </option>
                    {this.state.makes.map((option) => {
                      return (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className={classes.SearchNinputElementWraper}>
                  <p className="mt-3">Mileage</p>
                  <input
                    className={classes.textInput}
                    type="number"
                    placeholder="Mileage"
                    value={this.state.Milage}
                    onChange={(event) => {
                      this.setState({
                        Milage: event.target.value,
                      });
                    }}
                  />
                </div>
                <div className={classes.SearchNinputElementWraper}>
                  <p className="mt-3">Model</p>
                  <select
                    name="vehicle_model_id"
                    onChange={(event) => {
                      this.selectModelsChangedHandler(
                        event.target.name,
                        event.target.value
                      );
                    }}
                  >
                    <option
                      value={
                        this.props.postToEdit
                          ? this.props.postToEdit.vehicle_model.id
                          : ""
                      }
                    >
                      {this.props.postToEdit
                        ? this.props.postToEdit.vehicle_model.name
                        : "Models"}
                    </option>
                    {this.state.filterdModels.map((model) => {
                      return (
                        <option key={model.id} value={model.id}>
                          {model.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {/* <select >
                                <option value=''>Origin</option>
                                <option value=''>test</option>
                                <option value=''>test</option>
                            </select> */}
                <div className={classes.SearchNinputElementWraper}>
                  <p className="mt-3">Year</p>
                  <input
                    className={classes.textInput}
                    type="number"
                    min="1970"
                    max="2020"
                    placeholder="Year"
                    value={this.state.year_of_manufacture}
                    onChange={(event) => {
                      this.setState({
                        year_of_manufacture: event.target.value,
                      });
                    }}
                  />
                </div>
                <div className={classes.SearchNinputElementWraper}>
                  <p className="mt-3">Variant</p>
                  <select
                    name="vehicle_variant_id"
                    onChange={(event) => {
                      this.selectVariantsChangedHandler(
                        event.target.name,
                        event.target.value
                      );
                    }}
                  >
                    <option
                      value={
                        this.props.postToEdit
                          ? this.props.postToEdit.vehicle_variant.id
                          : ""
                      }
                    >
                      {this.props.postToEdit
                        ? this.props.postToEdit.vehicle_variant.name
                        : "Variants"}
                    </option>
                    {this.state.filtredVariants.map((variant) => {
                      return (
                        <option key={variant.id} value={variant.id}>
                          {variant.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className={classes.SearchNinputElementWraper}>
                  <p className="mt-3">Price</p>
                  <input
                    className={classes.textInput}
                    type="number"
                    placeholder="Price"
                    value={this.state.Price}
                    onChange={(event) => {
                      this.setState({
                        Price: event.target.value,
                      });
                    }}
                  />
                </div>
                <div className={classes.SearchNinputElementWraper}>
                  <p className="mt-3">Country</p>
                  <select
                    name="country_id"
                    onChange={(event) => {
                      this.selectCountryChangedHandler(
                        event.target.name,
                        event.target.value
                      );
                    }}
                  >
                    <option
                      value={
                        this.props.postToEdit
                          ? this.props.postToEdit.country.id
                          : ""
                      }
                    >
                      {this.props.postToEdit
                        ? this.props.postToEdit.country.name
                        : "Country"}
                    </option>
                    {this.state.countries.map((option) => {
                      return (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className={classes.SearchNinputElementWraper}>
                  <p className="mt-3">State</p>
                  <select
                    name="state_id"
                    onChange={(event) => {
                      this.selectStatesChangedHandler(
                        event.target.name,
                        event.target.value
                      );
                    }}
                  >
                    <option
                      value={
                        this.props.postToEdit
                          ? this.props.postToEdit.state.id
                          : ""
                      }
                    >
                      {this.props.postToEdit
                        ? this.props.postToEdit.state.name
                        : "State"}
                    </option>
                    {this.state.filterdStates.map((option) => {
                      return (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className={classes.SearchNinputElementWraper}>
                  <p className="mt-3">Area</p>
                  <select
                    name="area_id"
                    onChange={(event) => {
                      this.selectAreasChangedHandler(
                        event.target.name,
                        event.target.value
                      );
                    }}
                  >
                    <option
                      value={
                        this.props.postToEdit
                          ? this.props.postToEdit.area.id
                          : ""
                      }
                    >
                      {this.props.postToEdit
                        ? this.props.postToEdit.area.name
                        : "Area"}
                    </option>
                    {this.state.filterdAreas.map((option) => {
                      return (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <Map
                setCoordinate={this.setCoordinateHandler}
                coords={
                  this.props.postToEdit
                    ? {
                        lat: this.props.postToEdit.lat,
                        lng: this.props.postToEdit.lng,
                      }
                    : null
                }
              />
              <div className={classes.Controls}>
                <button type="submit" className={classes.Btn}>
                  Preview Post
                </button>
                {this.props.postToEdit && this.props.postMode && (
                  <button
                    type="button"
                    className={`${classes.Btn} ${classes.Rest}`}
                    onClick={(event) => {
                      this.props.history.push("/Activites");
                      this.props.onDeleteActivityPost(this.props.postToEdit.id);
                    }}
                  >
                    Delete
                  </button>
                )}
              </div>
            </form>
          </div>
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    sendingPostToDraft: state.Landing.sendingPostToDraft,
    draftPost: state.Landing.draftPost,
    error: state.Landing.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSendPostAsDraft: (vehicleType, data, mediaData, vidMedia) => {
      dispatch(
        actionCreators.sendPostAsDraft(vehicleType, data, mediaData, vidMedia)
      );
    },
    onSaveEditedPost: (vType, postId, data, media, vidMedia) => {
      dispatch(
        actionCreators.putEditPost(vType, postId, data, media, vidMedia)
      );
    },
    onDeleteActivityPost: (id) => {
      dispatch(actionCreators.deleteAcitivityPost(id));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchOptions);
